import { getFormattedValue } from "../../lib/utils.js";
import { Basic } from "../basic.ts";
/**
 * @class MSText
 * @extends Basic
 * @classdesc Текст
 * */
export class MSText extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "text",
            "fontname",
            "fontsize",
            "texthorizontalalign",
            "textverticalalign",
            "fontitalic",
            "fontbold",
            "fontmultiline",
            "fontunderlined",
            "textcolor",
            "valueformat",
            "overflow",
            "horizontalpadding",
            "verticalpadding",
        ]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open", delegatesFocus: true });
        shadowRoot.innerHTML = "<div></div>";
        //if (!this.style.position) {
        //    this.style.position = 'absolute';
        //}
        this.style.display = "flex";
        this.style.overflow = "hidden";
        this._text = shadowRoot.querySelector("div"); 
        this._text.style.whiteSpace = "pre";
        this._textValue = "";

        //from set base params
        this.style.justifyContent = "center"; //this.texthorizontalalign = 1;
        this.style.textAlign = "center";
        this.style.alignItems = "center"; //this.textverticalalign = 1;
        this._text.style.fontFamily = "Tahoma";
        this._text.style.fontSize = 12;
        this._text.style.color = "rgb(80,80,80)";
        this.style.borderWidth = 0;
        this.style.backgroundColor = "Transparent";
    }

    _parsePadding(value) {
        if (typeof value !== "string") return [0, 0];
        const parts = value.trim().split(/\s+/).map(Number).filter(n => !isNaN(n));
        if (parts.length === 1) return [parts[0], parts[0]];
        return [parts[0], parts[1]];
    }

    get horizontalpadding() {
        return this._horizontalpadding;
    }

    set horizontalpadding(value) {
        this._horizontalpadding = value;
        const [left, right] = this._parsePadding(value);
        const align = +this._horizontalalign;
    
        // Центр → оба
        if (align === 1) {
            this._text.style.paddingLeft = `${left}px`;
            this._text.style.paddingRight = `${right}px`;
        }
        // Слева → только left
        else if (align === 0) {
            this._text.style.paddingLeft = `${left}px`;
            this._text.style.paddingRight = "0px";
        }
        // Справа → только right
        else {
            this._text.style.paddingLeft = "0px";
            this._text.style.paddingRight = `${right}px`;
        }
    }

    get verticalpadding() {
        return this._verticalpadding;
    }

    set verticalpadding(value) {
        this._verticalpadding = value;
        const [top, bottom] = this._parsePadding(value);
        const valign = +this._verticalalign;
    
        if (valign === 1) {
            this._text.style.paddingTop = `${top}px`;
            this._text.style.paddingBottom = `${bottom}px`;
        } else if (valign === 0) {
            this._text.style.paddingTop = `${top}px`;
            this._text.style.paddingBottom = "0px";
        } else {
            this._text.style.paddingTop = "0px";
            this._text.style.paddingBottom = `${bottom}px`;
        }
    }

    get backgroundcolor() {
        return this._backgroundcolor;
    }

    set backgroundcolor(value) {
        super.backgroundcolor = value;
        this._calcBlockShadow();
    }

    get shadowsize() {
        return this._shadowsize;
    }
    set shadowsize(value) {
        value = parseInt(value, 10);
        if (value >= 0) {
            this._shadowsize = value;
            this._calcBlockShadow();
        }
    }

    get shadowcolor() {
        return this._shadowcolor;
    }
    set shadowcolor(value) {
        value = this.tryToGetUserColor(value);
        this._shadowcolor = value ? this._transformHexColor(value) : "";
        this._calcBlockShadow();
    }

    _calcBlockShadow() {
        if (!this._shadowsize || !this._shadowcolor) {
            this.style.boxShadow = "";
            this._text.style.textShadow = "";
            return;
        }
        if (
            !this.backgroundcolor ||
            this.backgroundcolor.toLowerCase() === "transparent"
        ) {
            this.style.boxShadow = "";
            this._text.style.textShadow = `
                ${this._shadowsize}px
                ${this._shadowsize}px
                1px
                ${this._shadowcolor}`;
        } else {
            this._text.style.textShadow = "";
            this.style.boxShadow = `
                ${this._shadowsize}px
                ${this._shadowsize}px
                1px 0
                ${this._shadowcolor}`;
        }
    }
    /**
     * Формат значений
     * @type {string}
     */
    get valueformat() {
        return this._valueFormat;
    }
    set valueformat(format) {
        const value =
            this._sourceValue !== undefined && this._sourceValue !== null
                ? this._sourceValue
                : "";
        format = format.trim();
        if (format) {
            this._valueFormat = format;
            this._text.innerText = this._textValue = this._getDisplayValue(
                format,
                value
            );
        } else {
            this._valueFormat = "";
            this._text.innerText = this._textValue = this._sourceDateObj
                ? this._getDisplayValue(
                    window._enums.DefaultDateFormat[this._sourceDateObj.type]
                )
                : value;
        }
    }
    /**
     * Текст
     * @type {string}
     */
    get text() {
        return this._textValue;
    }
    set text(value) {
        if (value === undefined) return;
        const decoded = typeof value === 'string'
            ? value.replace(/&nbsp;/g, "\u00A0")
            : value
        this._sourceValue = decoded;
        this._text.innerText = this._textValue = this._valueFormat
            ? this._getDisplayValue(this._valueFormat)
            : decoded;
        this._detectScroll();
    }

    _detectScroll() {
        if (this._overflow || this._toBool(this.getAttribute("overflow"))) {
            this.hasVerticalScrollbar = this.scrollHeight > this.clientHeight;
            this.hasHorizontalScrollbar = this.scrollWidth > this.clientWidth;
            if (this.hasHorizontalScrollbar) {
                this._text.style.width = "100%";
            } else {
                this._text.style.width = "";
            }
            if (this.hasVerticalScrollbar) {
                this._text.style.height = "100%";
            } else {
                this._text.style.height = "";
            }
        }
    }

    _getDisplayValue(format, value = this._sourceValue) {
        // Обрезаем значение, только если пришёл формат
        const hasFormat = format && format.toLowerCase().indexOf('f') > -1;
        if (hasFormat && typeof value === "string") {
            let idx = value.indexOf(" ");
            if (idx >= 0) value = value.substring(0, idx);
        }

        return getFormattedValue(
            format,
            this._sourceDateObj ? this._sourceDateObj.value : value,
            this._sourceDateObj ? this._sourceDateObj.type : "",
            { sourceId: this.id, targetId: this.id }
        );
    }

    get sourceDateObj() {
        return this._sourceDateObj;
    }
    set sourceDateObj(timeObj) {
        this._sourceDateObj = timeObj;
    }
    /**
     * Шрифт
     * @type {string}
     */
    get fontname() {
        return this._fontname;
    }
    set fontname(value) {
        this._fontname = value;
        this._text.style.fontFamily = '"' + value + '"';
    }
    /**
     * Размер текста
     * @type {number}
     */
    get fontsize() {
        return this._fontSize;
    }
    set fontsize(value) {
        this._fontSize = value;
        this._text.style.fontSize = `${value}px`;
    }
    /**
     * Горизонтальное выравнивание
     * @type {enum}
     */
    get texthorizontalalign() {
        return this._horizontalalign;
    }
    set texthorizontalalign(value) {
        this._horizontalalign = value;
        this.style.justifyContent = window._enums.AlignHorizontal[value];
        this.style.textAlign = window._enums.AlignText[value];

    }
    /**
     * Вертикальное выравнивание
     * @type {enum}
     */
    get textverticalalign() {
        return this._verticalalign;
    }
    set textverticalalign(value) {
        this._verticalalign = value;
        this.style.alignItems = window._enums.AlignVertical[value];
    }
    /**
     * Курсив
     * @type {bool}
     */
    get fontitalic() {
        return this._italic;
    }
    set fontitalic(value) {
        this._italic = value || false;
        this._text.style.fontStyle = this._toBool(value) ? "italic" : "normal";
    }
    /**
     * Жирный
     * @type {bool}
     */
    get fontbold() {
        return this._bold || false;
    }
    set fontbold(value) {
        this._bold = value;
        this._text.style.fontWeight = this._toBool(value) ? "bold" : "normal";
    }
    /**
     * Многострочность
     * @type {bool}
     */
    get fontmultiline() {
        return this._multiline;
    }
    set fontmultiline(value) {
        this._multiline = value;
        this._text.style.whiteSpace = this._toBool(value) ? "pre-wrap" : "pre";
        this._text.style.wordBreak = this._toBool(value) ? "break-word" : "normal";
    }
    /**
     * Подчеркнутый
     * @type {bool}
     */
    get fontunderlined() {
        return this._underline || false;
    }
    set fontunderlined(value) {
        this._underline = value;
        this._text.style.textDecoration = this._toBool(value)
            ? "underline"
            : "none";
    }

    /**
     * Цвет текста
     * @type {string}
     */
    get textcolor() {
        return this._text.style.color;
    }
    set textcolor(value) {
        this._text.style.color = this.tryToGetUserColor(value);
    }
    /**
     * Отображение прокрутки
     * @type {bool}
     */
    get overflow() {
        return this._overflow;
    }
    set overflow(v) {
        this._overflow = this._toBool(v);
        this.style.overflow = this._overflow ? "auto" : "hidden";
        this._detectScroll();
    }

    disconnectedCallback() {
        if (this._text) {
            this._text = null
        }
        super.disconnectedCallback();
    }
}
